function toggleForgottenPassword(){
	$(this).toggleClass("open");
	$(".forgottenPass").slideToggle(500);
}

function initLoginValidation(){
    _loginValidation.Items = _loginValidation.Formular.find("*[validate='true']");
    _loginValidation.SummeryBox = $(".loginError");
}

function validateLogin(){
	_loginValidation.ShowSummery = true;
    _loginValidation.Validate();
    return _loginValidation.IsValid;
}

function initForgottenPasswordValidation(){
	_forgottenPasswordValidation.Items = _forgottenPasswordValidation.Formular.find("*[validate='true']");
    _forgottenPasswordValidation.SummeryBox = $(".forgottenError");
}

function validateForgottenPassword(){
	_forgottenPasswordValidation.ShowSummery = true; 
    _forgottenPasswordValidation.Validate();
    return _forgottenPasswordValidation.IsValid;
} 

function forgottenConfirmation(){
    var _forgottenPassForm = $("#forgottenPassForm");
    if(_forgottenPassForm.hasClass("showSwal")){
        swal(_forgottenPassForm.data("swalhead"), _forgottenPassForm.data("swaltext"), "success");
    }
}